import { RootState } from 'editor/src/store/index';

import getPlugin from './getPlugin';

const getPluginType = (state: RootState, pluginName: string) => getPlugin(state, pluginName)?.type;

export default getPluginType;
